const TOKEN_KEY = "access_token";

export const getAccessToken = () => localStorage.getItem(TOKEN_KEY);

export const isTokenValid = (token) => {
  if (!token) return false;
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return typeof payload.exp === "number" && payload.exp * 1000 > Date.now();
  } catch {
    return false;
  }
};

export const hasValidToken = () => isTokenValid(getAccessToken());
